import React, { useState, useEffect } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { GalleryIcon, ThumbsIcon } from "./Icons";
import { Box, Flex, Text } from "@chakra-ui/react";
import {API_BASE_IMAGES} from "../OldApp";

const PhotoGallery = ({ propertyImages }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [photos, setPhotos] = useState([]);

  const openLightbox = () => {
    setCurrentImage(0); // Start the carousel at the first image
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  useEffect(() => {
    const photoArr = propertyImages.map((image) => ({
      src: API_BASE_IMAGES + image.path_1400,
      width: 800,
      height: 600,
    }));

    setPhotos(photoArr);
  }, [propertyImages]);

  return (
    <>
      {photos && photos.length && (
        <div>
          <Flex
            pos={"absolute"}
            left={8}
            bottom={8}
            w={12}
            h={12}
            borderRadius={"full"}
            border={"1px solid white"}
            justifyContent={"center"}
            alignItems={"center"}
            onClick={openLightbox}
            cursor={"pointer"}
          >
            <Flex
              pos={"absolute"}
              borderRadius={"full"}
              w={"17px"}
              h={"17px"}
              justifyContent={"center"}
              alignItems={"center"}
              bgColor={"BrightTurquoise"}
              right={-1}
              top={-1}
            >
              <Text fontWeight={"600"} fontSize={"3xs"} as={"span"}>
                { propertyImages.length }
              </Text>
            </Flex>
            <GalleryIcon w={6} h={6} />
          </Flex>
          <ModalGateway>
            {viewerIsOpen && (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photos.map((photo) => ({
                    ...photo,
                    srcset: photo.srcSet,
                    caption: photo.title,
                  }))}
                />
              </Modal>
            )}
          </ModalGateway>
        </div>
      )}
    </>
  );
};

export default PhotoGallery;
